import { keccak256 } from "ethereum-cryptography/keccak.js";
import { utf8ToBytes } from "ethereum-cryptography/utils.js";
import { ensureIfUint8Array, isAddress, uint8ArrayToHexString, } from "../validators";
import { isNullish } from "../validators/object";
/**
 * Private helper function to validate and trim an address
 * @param address The address to validate and trim
 * @returns The trimmed address if valid, null otherwise
 */
var _validateAndTrimAddress = function (address) {
    if (typeof address === "string" && address.trim() !== "" && isAddress(address.trim())) {
        return address.trim();
    }
    return null;
};
/**
 * Type guard to check if an address is valid and non-empty after trimming.
 * Note: This function checks if the trimmed value of the address is valid, but does not guarantee that the input address itself is trimmed.
 * If you require a trimmed address, use `getValidAddress(address)` to obtain the trimmed value.
 * @param address The address to validate
 * @returns true if the trimmed address is valid and non-empty, false otherwise.
 * @remarks
 * This type guard only ensures that the trimmed value is a valid Address. The original input may still contain leading or trailing whitespace.
 */
export var isValidAddress = function (address) {
    return _validateAndTrimAddress(address) !== null;
};
/**
 * Validates and returns a trimmed valid address.
 * This function trims the input address and validates it, returning the trimmed value if valid.
 * @param address The address to validate and trim
 * @returns The trimmed address if valid, null otherwise
 * @remarks
 * This function is the preferred way to get a validated, trimmed address for use in your application.
 */
export var getValidAddress = function (address) {
    return _validateAndTrimAddress(address);
};
export var toChecksumAddress = function (address) {
    if (!isAddress(address, false)) {
        throw new Error("Invalid address " + address);
    }
    var lowerCaseAddress = address.toLowerCase().replace(/^0x/i, "");
    var hash = uint8ArrayToHexString(keccak256(ensureIfUint8Array(utf8ToBytes(lowerCaseAddress))));
    if (isNullish(hash) ||
        hash ===
            "0xc5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470")
        return ""; // // EIP-1052 if hash is equal to c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470, keccak was given empty data
    var checksumAddress = "0x";
    var addressHash = hash.replace(/^0x/i, "");
    for (var i = 0; i < lowerCaseAddress.length; i += 1) {
        // If ith character is 8 to f then make it uppercase
        if (parseInt(addressHash[i], 16) > 7) {
            checksumAddress += lowerCaseAddress[i].toUpperCase();
        }
        else {
            checksumAddress += lowerCaseAddress[i];
        }
    }
    return checksumAddress;
};
//# sourceMappingURL=address.js.map